import { slide, fade, fly } from "svelte/transition";
export function merge(...args) {
    return (node, options) => {
        const results = args.map(_ => _(node, options));
        const css = results.filter(_ => _.css);
        const tick = results.filter(_ => _.tick);
        return {
            duration: options.duration,
            easing: options.easing,
            delay: options.delay,
            css: (t, u) => css.map(_ => _.css(t, u)).join(';'),
            tick: (t, u) => tick.forEach(_ => _.tick(t, u)),
        };
    };
}
export const fadeSlide = merge(slide, fade);
